import { meridioPlanEnrollmentService } from "./service";
import { IEnrollInMeridioRequest, IEnrollInMeridioResponse } from "./types";

export const enrollInMeridio = async (
  request: IEnrollInMeridioRequest
): Promise<IEnrollInMeridioResponse> => {
  const { data } = await meridioPlanEnrollmentService.post("", request);
  return data;
};
